import getSuppliers from './getSuppliers';

/**
 * Used to get the suppliers matches.
 * Auto matches based on supplier name are also included in results.
 * @param {object} props
 * @param {import('./MatchSupplier').DataImport} props.importData - the full dataImport
 * @param {{ aliases: string[]?, partnerId: string }[]} props.partners - all brand partners nodes
 * @returns
 */
export default function getSuppliersMatched({ importData, partners }) {
  if (!importData) return [];
  const uniqSuppliers = getSuppliers({ importData });
  const suppliers = importData.suppliers || [];
  const matchedSuppliersMapped = suppliers?.reduce((acc, supplier) => {
    acc[supplier.supplier] = supplier.partnerId;
    return acc;
  }, {});
  const unmatchedSuppliers = uniqSuppliers.filter(
    (supplier) => !matchedSuppliersMapped?.[supplier]
  );
  /**
   * @type {{ partnerId: string, supplier: string }[]}
   */
  const autoMatches =
    partners?.reduce((acc, partner) => {
      partner?.aliases?.forEach((alias) => {
        if (unmatchedSuppliers.includes(alias)) {
          acc.push({ partnerId: partner.partnerId, supplier: alias });
        }
      });
      return acc;
    }, []) || [];

  return [...autoMatches, ...suppliers];
}
